module.exports = __webpack_public_path__ + "img/custom.baef8514.png";